import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const NotePageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: ${pxToRem(32)};
  background: #fff;
  border-radius: ${pxToRem(16)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(8)} rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${pxToRem(8)};
  margin-bottom: ${pxToRem(16)};
`;

export const ToolbarButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;

  img {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const TextArea = styled.textarea`
  flex: 1; 
  width: 100%;
  margin-top: ${pxToRem(16)};
  margin-bottom: ${pxToRem(16)};
  padding: ${pxToRem(16)};
  font-size: ${pxToRem(16)};
  border: ${pxToRem(1)} solid #ccc;
  border-radius: ${pxToRem(8)};
  resize: none;
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
              0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const SaveButton = styled.button`
  padding: ${pxToRem(14)} ${pxToRem(28)};
  width: ${pxToRem(369)};
  border: none;
  border-radius: ${pxToRem(12)};
  background: rgb(114, 82, 220);
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(18)};
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #603cbc;
  }
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  color: #6c757d;
  margin-bottom: ${pxToRem(16)};
`;

export const BreadcrumbItem = styled.span`
  color: rgba(31, 10, 53, 0.5);
`;
